export default function IconDownload({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.53 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.00098 1.09277V11.6365"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83789 8.47363L9.00102 11.6368L12.1641 8.47363"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6374 3.72852H13.2176C13.4945 3.72852 13.7687 3.78306 14.0246 3.88903C14.2804 3.99501 14.5129 4.15034 14.7087 4.34615C14.9045 4.54197 15.0598 4.77444 15.1658 5.03028C15.2718 5.28613 15.3263 5.56034 15.3263 5.83727V14.7995C15.3263 15.0764 15.2718 15.3506 15.1658 15.6064C15.0598 15.8623 14.9045 16.0947 14.7087 16.2906C14.5129 16.4864 14.2804 16.6417 14.0246 16.7477C13.7687 16.8537 13.4945 16.9082 13.2176 16.9082H4.78258C4.2233 16.9082 3.68693 16.686 3.29147 16.2906C2.896 15.8951 2.67383 15.3587 2.67383 14.7995V5.83727C2.67383 5.27799 2.896 4.74162 3.29147 4.34615C3.68693 3.95069 4.2233 3.72852 4.78258 3.72852H6.36414"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
